import moment from "moment-timezone";

export const dateFormatter = (date) => {
  if (date && typeof date === "string" && moment(date, true).isValid())
    return moment(date)
      .tz("Europe/Madrid")
      .format("DD/MM/YYYY,[\n] HH:mm:ss");
  return "-";
};

export const dateFormatterDDMMMYYY = (date) => {
  if (date && typeof date === "string" && moment(date, true).isValid())
    return moment(date)
      .tz("Europe/Madrid")
      .format("DD MMM YYYY");
  else return "-";
};

export const durationFormatter = (seconds) => {
  if (seconds && typeof seconds === "number")
    return (
      Math.floor(moment.duration(seconds * 1000).asHours()) +
      moment.utc(seconds * 1000).format(":mm:ss")
    );
  return "00:00:00";
};

export const TimeStampToSeconds = (startTime) => {
  if (startTime) {
    if (typeof startTime === "number") return startTime;
    if (typeof startTime === "string")
      return moment(startTime, "hh:mm:ss").diff(
        moment().startOf("day"),
        "seconds"
      );
  }
  return 0;
};

export const MinutesToTimestamp = (minutes) => {
  if (minutes && typeof minutes === "number")
    return moment.utc(minutes * 1000).format("HH:mm:ss");
  else return "00:00:00";
};

export const SecondsToMinutes = (seconds) => {
  if (seconds) {
    if (typeof seconds === "number") {
      return Math.ceil(seconds / 60);
    }
  }
  return 0;
};

export const capitalize = (word) =>
  word && word[0].toUpperCase() + word.slice(1);
